var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"FormSect"},[(_vm.title)?_c('div',{staticClass:"title"},[_c('h3',[_vm._v(_vm._s(_vm.title))]),(_vm.sub)?_c('div',{staticClass:"sub"},[_vm._v(" "+_vm._s(_vm.sub)+" ")]):_vm._e()]):_vm._e(),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }